import { EventEmitter } from 'events';
import { Realtime } from './Realtime';
import { Orderbook } from './Orderbook';

export class Bitfinex extends EventEmitter {
  private realtime: Realtime;
  private orderbook = new Orderbook();
  private ticker = {
    ltp: 0,
    best_bid: 0,
    best_ask: 0,
  };
  private subscribed = false;
  constructor() {
    super();
    const channels = [
      {
        event: 'subscribe',
        channel: 'book',
        symbol: 'tBTCUSD',
        prec: 'P1',
        len: '100',
      },
      {
        event: 'subscribe',
        channel: 'ticker',
        symbol: 'tBTCUSD',
      },
      {
        event: 'subscribe',
        channel: 'ticker',
        symbol: 'fUSD',
      },
      {
        event: 'subscribe',
        channel: 'ticker',
        symbol: 'fBTC',
      },
      {
        event: 'subscribe',
        channel: 'trades',
        symbol: 'tBTCUSD',
      },
    ];
    this.realtime = new Realtime(channels);
    this.realtime.on('book', (data) => {
      if (this.subscribed) {
        this.orderbook._setData(data);
        this.emit('orderbook', this.orderbook);
      }
    });
    this.realtime.on('reSubscribing', () => {
      this.subscribed = false;
      this.orderbook.clear();
      this.emit('subscribeStatus', { status: false });
    });
    this.realtime.on('subscribeOrderbook', () => {
      this.subscribed = true;
      this.emit('subscribeStatus', { status: true });
    });
    this.realtime.on('trades', (data) => {
      if (data[1] === 'te') {
        this.ticker.ltp = data[2][3];
        this.emit('ticker', this.ticker);
        this.emit('trades', data[2]);
      }
    });
    this.realtime.on('ticker', (data) => {
      if (this.ticker.ltp === 0) {
        this.ticker.ltp = data[1][6];
      }
      this.ticker.best_bid = data[1][0];
      this.ticker.best_ask = data[1][2];
      this.emit('ticker', this.ticker);
    });
    this.realtime.on('btcTicker', (data) => {
      const btcTicker = {
        frr: data[1][0],
      };
      this.emit('btcTicker', btcTicker);
    });
    this.realtime.on('usdTicker', (data) => {
      const usdTicker = {
        frr: data[1][0],
      };
      this.emit('usdTicker', usdTicker);
    });
  }
  public setFactor(factor: number) {
    this.realtime.setFactor(factor);
  }
}
